import PlatformsGroupItem from "./PlatformsGroupItem";

function PlatformsGroup({ data }) {
  return (
    <div className="flex flex-row gap-3 text-3xl">
      {data.map((item, index) => (
        <PlatformsGroupItem
          key={index}
          name={item.name}
          icon={item.icon}
          to={item.to}
        />
      ))}
    </div>
  );
}

export default PlatformsGroup;
